"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var apiLotDetail = _interopRequireWildcard(require("@/api/lotdetail"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'KObjectifDebourse',
  data: function data() {
    return {
      changeCoefObjectifDebourse: false,
      oldCoefObjectifDebourse: null,
      focusCoefObjectifDebourse: false,
      // --
      CONST: CONST
    };
  },
  mounted: function mounted() {
    var _this = this;

    _eventBus.EventBus.$on('REFRESH', function () {
      if (_this.focusCoefObjectifDebourse && _this.$refs.coefObjectifDebourse) {
        _this.setFocusKOD();

        _this.focusCoefObjectifDebourse = false;
      }
    });
  },
  computed: {
    affaire: function affaire() {
      return this.$store.getters.affaire.affaire;
    },
    errorCoefObjectifDebourse: function errorCoefObjectifDebourse() {
      var v = this.affaire.coef_objectif_debourse;
      return v === '' || isNaN(v) || v < 0 || v > 1;
    },
    coefObjectifDebourse: {
      get: function get() {
        return this.affaire.coef_objectif_debourse;
      },
      set: function set(value) {
        // pour gérer le clic sur le bouton annuler
        if (this.changeCoefObjectifDebourse === false && this.oldCoefObjectifDebourse === null) {
          this.changeCoefObjectifDebourse = true; // pour afficher les boutons enregistrer ou annuler

          this.oldCoefObjectifDebourse = this.affaire.coef_objectif_debourse; // pour annuler et restaurer l'ancienne valeur
        }

        this.affaire.coef_objectif_debourse = value;
      }
    }
  },
  methods: {
    // ----
    setFocusKOD: function setFocusKOD() {
      var _this2 = this;

      if (this.$refs.coefObjectifDebourse) {
        this.$nextTick(function () {
          _this2.$refs.coefObjectifDebourse.focus();
        });
      }
    },
    handleInputKOD: function handleInputKOD() {
      var _this3 = this;

      // -- pour calcul en temps réel de la colonne K objectif de deboursé au changement du coef
      this.$store.getters.affaire.lotsDetail.forEach( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(row, index) {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  row.coef_objectif_debourse = _this3.affaire.coef_objectif_debourse;
                  _context.next = 3;
                  return _this3.$store.dispatch('affaire/setLotDetail', row);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }()); // -- appel de recalcul de toutes les formules

      _eventBus.EventBus.$emit('REFRESH_CALCULS');

      this.focusCoefObjectifDebourse = true; // envoi un signal pour verouiller les autres champs et masque les boutons d'actions

      _eventBus.EventBus.$emit('SAVE_CANCEL', true);
    },
    handleCancelKOD: function handleCancelKOD() {
      var _this4 = this;

      // restauration des ancienns valeurs + recalcul en temps réel de toutes les colonnes
      this.affaire.coef_objectif_debourse = this.oldCoefObjectifDebourse;
      this.$store.getters.affaire.lotsDetail.forEach( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee2(row, index) {
          return _regenerator.default.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  row.coef_objectif_debourse = _this4.affaire.coef_objectif_debourse;
                  _context2.next = 3;
                  return _this4.$store.dispatch('affaire/setLotDetail', row);

                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
      this.changeCoefObjectifDebourse = false;
      this.oldCoefObjectifDebourse = null;

      _eventBus.EventBus.$emit('REFRESH_CALCULS'); // envoi un signal pour déverouiller les autres champs et afficher les boutons d'actions


      _eventBus.EventBus.$emit('SAVE_CANCEL', false);
    },
    handleSaveKOD: function handleSaveKOD() {
      var _this5 = this;

      if (!this.errorCoefObjectifDebourse) {
        this.$loader(true);
        var data = {
          coef_objectif_debourse: this.affaire.coef_objectif_debourse
        };
        apiAffaire.update(this.affaire.id, data).then(function (results) {
          if (results.affectedRows > 0) {
            _this5.changeCoefObjectifDebourse = false; // envoi un signal pour déverouiller les autres champs et afficher les boutons d'actions

            _eventBus.EventBus.$emit('SAVE_CANCEL', false); // ---


            _this5.oldCoefObjectifDebourse = null; // ---

            var lots = _this5.$store.getters.affaire.lots;
            var idsLot = lots.map(function (u) {
              return u.id;
            }).join(',');
            apiLotDetail.updateAllByLotId(idsLot, {
              coef_objectif_debourse: _this5.affaire.coef_objectif_debourse
            }).then(function (results) {
              _this5.$message('Modification enregistrée avec succès');

              _this5.$loader(false);
            }).catch(function (error) {
              _this5.$message(error);

              _this5.$loader(false);
            });
          }
        }).catch(function (error) {
          _this5.$message(error);
        });
      }
    }
  }
};
exports.default = _default;